<template>
  <div>
    <!-- <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
    /> -->
    <div class="detail-main">
      <div class="detail">
        <div class="shopState">
          <div>{{ detailList.branchName }}</div>
          <div v-if="detailList.orderType != 20">
            {{ detailList.statusName }}
          </div>
          <div v-else>{{ detailList.payStatusName }}</div>
        </div>
        <div class="detail-head">
          <div>{{ $t('orderNo') }}：</div>
          <div>{{ detailList.orderNo }}</div>
        </div>
        <div class="detail-time">
          <div>{{ $t('orderTime') }}：</div>
          <div>{{ detailList.createTime || "" }}</div>
        </div>

        <div class="detail-time">
          <div> {{ $t('paySuccessReserveTime') }}</div>
          <div>{{ getTime }}</div>
        </div>
        <!-- v-show="detailList.statusName === '已完成' || detailList.statusName === '已退款' || detailList.statusName === '配送中'"  -->
        <div class="detail-footer">
          <div ref="qrCode" :class="['qrCode', detailList.status !== '4'?'unablecode':'' ]"></div>
          <div :class="['normal-font', detailList.status === '11'?'unable':'' ]">
            {{ $t('foodNumber') }}：{{ detailList.mealTakingNum || "" }}
          </div>
        </div>
      </div>
      <!-- 菜品详情 -->
      <div class="meal-detail">
        <div class="title">{{ $t('dishDetail') }}</div>
        <div>
          <div
            class="meal-type"
            v-for="(item, index) in detailList.itemList"
            :key="index"
          >
            <div style="width: 55px; height: 55px">
              <img class="mealImg" :src="item.productPic" alt="" />
            </div>
            <div class="mealoutin">
              <div class="meal-name">
                <div>{{ item.productName }}</div>
                <div
                  class="price-main"
                  v-if="item.realPrice == null || item.realPrice == item.price"
                >
                  <!-- <div>
                    ￥{{ ((item.price * item.quantity) / 100).toFixed(2) }}
                  </div> -->
                </div>
                <div class="price-main" v-else>
                  <div class="vipPrice">
                    ¥{{ ((item.realPrice * item.quantity) / 100).toFixed(2) }}
                  </div>
                  <div class="oldOrder">
                    ￥{{ ((item.price * item.quantity) / 100).toFixed(2) }}
                  </div>
                </div>
              </div>
              <div class="mealCount">×{{ item.quantity }}</div>
            </div>
          </div>
        </div>
        <div class="allCount">
          {{ $t('totalDish', [getAllCount]) }}
        </div>
        <div class="remark">
          <div class="label">{{ $t('orderRemark') }}：</div>
          <div class="value">{{detailList.note }}</div>
        </div>
        <div class="pack" v-if="detailList.packFee != 0 && $route.query.orderType != 39">
          <div>{{ $t('packageFee') }}</div>
          <div>￥{{ (detailList.packFee / 100).toFixed(2) }}</div>
        </div>
        <div class="pack" v-if="detailList.deliveryFee != 0 && $route.query.orderType != 39">
          <div>{{ $t('shippingFee') }}</div>
          <div>￥{{ (detailList.deliveryFee / 100).toFixed(2) }}</div>
        </div>
        <div class="price-total">
          <div class="totalF">
            <div class="count" v-if="detailList.itemList">
              <!-- {{ $t('totalDish', [detailList.itemList.length]) }} -->
            </div>
            <div class="price">
              <div class="pricetext">{{ $t('totalFee') }}￥</div>
              <div class="peiceT">
                {{ (detailList.realFee / 100).toFixed(2) }}
              </div>
            </div>
          </div>
          <div class="payment">
            <div>{{ $t('paymentType') }}</div>
            <div>{{ detailList.payType }}</div>
          </div>
        </div>
      </div>
      <!-- 订单地址 -->
      <!-- <div
        class="order-adress"
        v-if="detailList.takeawayAddress && detailList.takeawayAddress.address"
      >
        <div class="counte">
          <div>订单地址：</div>
          <div>{{ detailList.takeawayAddress.address }}</div>
        </div>
      </div> -->
      <!-- 配送时间 -->
      <!-- <div class="order-adress">
        <div class="counte">
          <div>配送时间：</div>
          <div>{{ detailList.deliveryTimeStr }}</div>
        </div>
      </div> -->
<!--      -->
      <div class="orderMsg" v-if="$route.query.orderType == 39">
        <div >
          <div class="label">{{ $t('repastAddress') }}</div>
          <div class="value">{{detailList.multiLevelCategory && detailList.multiLevelCategory.levelName}}</div>
        </div>
      </div>
      <!-- 配送信息 -->
      <div class="orderMsg" v-if="detailList.status === '10' ">
         <div >
          <div class="label">{{ $t('completionTime') }}</div>
           <div class="value">{{detailList.delivererStatusFinishTime}}</div>
         </div>
         <div>
          <div class="label">{{ $t('remark') }}</div>
           <div class="value">{{detailList.deliveryRemark}}</div>
         </div>
        <div>
          <!-- <div class="label">{{ $t('attachments') }}</div> -->
          <div class="imglist" >
            <img v-for="item in detailList.deliveryRecordImages" :key="item" @click="showImg(item)" :src="item" alt="">
          </div>
        </div>
      </div>
      <!-- 退款成功 -->
      <div class="refund" v-if="detailList.refundStatus">
        <div>
          <div class="refund-statue">{{ detailList.refundStatusDesc }}</div>
          <div class="refund-time">{{ detailList.refundTime }}</div>
        </div>
        <div class="refund-price">
          {{ $t('refundMoney') }}￥{{ (detailList.refundFee / 100).toFixed(2) }}
        </div>
      </div>
      <!-- <div class="action-item" @click="handleEvaluate" v-if="!isComment">
        评价订单
      </div>
      <div class="action-item activeLok" @click="handleSeeEvalue" v-else>
        查看评价
      </div> -->
      <!-- <div
        class="pay-btn"
        v-if="detailList.orderType != 20 && detailList.statusName == '未支付'"
        @click="showPayAction = true"
      >
        支付
      </div> -->
      <van-popup
        v-model="showPayAction"
        :style="{ width: '80%', height: '40%' }"
      >
        <div class="popup-main">
          <div class="title">请选择支付方式</div>
          <div class="border"></div>
          <div class="payment">
            <van-radio-group v-model="payRadio">
              <div class="pay-item">
                <div style="display: flex; align-items: center">
                  <img src="@/assets/card.png" alt="" />
                  <div>卡支付</div>
                </div>
                <van-radio name="1" checked-color="#09BB07" />
              </div>
              <div class="pay-item">
                <div style="display: flex; align-items: center">
                  <img src="@/assets/ic_wxpay.png" alt="" />
                  <div>微信支付</div>
                </div>
                <van-radio name="2" checked-color="#09BB07" />
              </div>
            </van-radio-group>
          </div>
          <div class="btn-main">
            <div class="cancel-btn wid" @click="showPayAction = false">
              取消
            </div>
            <div class="wid" @click="handlePayOrder">确定</div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { Dialog } from "vant";
import wxPay from "@/utils/wxPay";
import { ImagePreview } from 'vant';

export default {
  data() {
    return {
      detailList: {},
      isComment: true,
      localData: {},
      showPayAction: false,
      payRadio: "1",
      language: ''
    };
  },
  // beforeRouteLeave(to, from, next) {
  //   if (to.path == "/card/package") {
  //     this.$vnode.parent.componentInstance.cache = {};
  //     this.$vnode.parent.componentInstance.keys = [];
  //   }
  //   next();
  // },
  activated() {},
  mounted() {
    this.language = localStorage.getItem('language');
    this.getOrderDateList();
    this.$nextTick(() => {
      this.handleCreateQrcode();
    });
  },
  computed: {
    getTime() {
      const res = this.detailList?.targetDate;
      if (res) {
        const result = res?.split(" ")
        result[1] =   this.detailList.mealTime || ""
        return result.join(' ');
      } else {
        return '-'
      }
    },
    getAllCount() {
      if (this.detailList?.itemList) {
        const res = this.detailList?.itemList.reduce((a,b) =>{
        return a + b.quantity
        }, 0)
        return res;
      }
     
    }

  },
  methods: {
    //二维码内容
    handleCreateQrcode() {
      new QRCode(this.$refs.qrCode, {
        text: `H${this.$route.query.orderNo}`,
        width: 100,
        height: 100,
        color: 'red',
      });
    },
    //获取详情数据
    getOrderDateList() {
      let data = {
        orderNO: this.$route.query.orderNo,
      };
      this.$authAjax
        .post("/api/wxapp/reserve/findOrderDetail", data)
        .then((res) => {
          let { data } = res.data;
          if (res.data.code == 200) {
            let statusTitleList = [
              this.$t('refundStatus1'),
              this.$t('refundStatus2'),
              this.$t('refundStatus3'),
              this.$t('refundStatus4'),
              this.$t('refundStatus5'),
              this.$t('refundStatus6'),
              this.$t('refundStatus7'),
            ];
            data.refundStatusDesc =
              statusTitleList[data.refundStatus] || "未知状态";
              
            this.detailList = data;
            this.localData = data;
            // this.handleIsComment(data);
          }
        });
    },
    //去支付
    handlePayOrder() {
      this.showPayAction = false;
      Dialog.alert({
        message: "￥" + (this.detailList.realFee / 100).toFixed(2),
        showCancelButton: true,
        confirmButtonText: "确认支付",
        confirmButtonColor: "#419DFB",
      })
        .then(() => {
          this.$toast.loading({
            message: "支付中...",
            forbidClick: true,
            loadingType: "spinner",
          });
          if (this.payRadio == "1") {
            let resD = {
              orderNo: this.detailList.orderNo,
            };
            this.$authAjax
              .post("/api/wxapp/new/reserve/order/card/pay", resD)
              .then((req) => {
                if (req.data.code == 200) {
                  this.$toast.success("支付成功");
                  setTimeout(() => {
                    this.$router.push({
                      path: "/order/paysuccess",
                      query: {
                        orderNo: this.detailList.orderNo,
                        branchId: this.detailList.branchId,
                        branchName: this.detailList.branchName,
                      },
                    });
                  }, 1000);
                } else {
                  this.$toast.fail(req.data.message);
                }
              });
          } else {
            let openId = localStorage.getItem("wxOpenId");
            let resDa = {
              miniPg: false,
              orderNo: this.detailList.orderNo,
              openId: openId,
            };
            this.$authAjax
              .post("/api/wxapp/new/reserve/order/wx/pay", resDa)
              .then((rec) => {
                rec.data.data.appId = "wx4bf1260c290f196c";
                if (typeof WeixinJSBridge == "undefined") {
                  if (document.addEventListener) {
                    document.addEventListener(
                      "WeixinJSBridgeReady",
                      wxPay(rec.data.data, () => {}),
                      false
                    );
                  } else if (document.attachEvent) {
                    document.attachEvent(
                      "WeixinJSBridgeReady",
                      wxPay(rec.data.data, () => {})
                    );
                    document.attachEvent(
                      "onWeixinJSBridgeReady",
                      wxPay(rec.data.data, () => {})
                    );
                  }
                } else {
                  wxPay(rec.data.data, () => {});
                }
              });
          }
        })
        .catch(() => {});
    },

    handleIsComment(order) {
      let data = {
        entityCode: "001",
        entityId: order.orderNo, //order.orderNo
        bizId: {
          "1_merchantId": order.shopId, //order.shopId
          "2_branchId": order.branchId || 9, //order.branchId ||
        },
      };
      this.$authAjax.post("/comment/record/getCommentRecords", data).then((res) => {
        let { data } = res.data;
        if (!data || !data.length) {
          this.isComment = false;
        }
      });
    },
    //评价订单
    handleEvaluate() {
      let localData = Object.assign({}, this.localData, {
        orderItems: this.localData.itemList,
      });
      localStorage.setItem(
        "o_" + this.localData.orderNo,
        JSON.stringify(localData)
      );
      this.$router.push({
        path: "/order/evalueOrder",
        query: {
          oid: this.localData.orderNo,
        },
      });
    },
    //查看订单
    handleSeeEvalue() {
      let localData = Object.assign({}, this.localData, {
        orderItems: this.localData.itemList,
      });
      localStorage.setItem(
        "o_" + this.localData.orderNo,
        JSON.stringify(localData)
      );
      this.$router.push({
        path: "/order/seeEvalue",
        query: {
          oid: this.localData.orderNo,
        },
      });
    },
    showImg(item) {
      ImagePreview([item]);

    }
  },
};
</script>

<style lang="scss" scoped>
.detail-main {
  width: 100%;
  height: 100vh;
  background: #f2f2f2;
  box-sizing: border-box;
  overflow: auto;
  .detail {
    width: 95%;
    // min-height: 320px;
    background: #fff;
    margin: 20px auto 0 auto;
    border-radius: 7px;
    padding: 10px 15px;
    box-sizing: border-box;
    position: relative;
    .shopState {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      position: relative;
      font-size: 12px;
      border-bottom: 1px solid #f4f5f6;
      div:nth-child(2) {
        padding: 6px 8px;
        color: #fff;
        text-align: center;
        background: linear-gradient(270deg, #75b55a 0%, #2d9561 100%);
        border-radius: 0px 8px 0px 8px;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .detail-head {
      font-size: 16px;
      margin: 2% 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div:nth-child(2) {
        color: #969696;
        font-size: 14px;
      }
    }
    .detail-time {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 5px 0;
      div:nth-child(1) {
        font-size: 16px;
      }
      div:nth-child(2) {
        font-size: 12px;
        font-weight: normal;
        color: #969696;
      }
    }
    .meal-time {
      font-size: 12px;
      color: #969696;
    }
  
    .detail-footer {
      width: 100%;
      margin-top: 4%;
      text-align: center;
      align-items: center;
      .qrCode {
        margin: auto;
        width: 100Px;
        height: 100Px;
      }
      .unablecode{
        // filter: blur(2px);
      }
      .unable {
        text-decoration: underline;
        color: gray;
      }
      .normal-font {
        font-size: 15px;
        margin-top: 8%;
      
      }
    }
  }
  .meal-detail {
    margin: auto;
    margin-top: 10px;
    background-color: white;
    border-radius: 8px;
    color: #000;
    width: 95%;
    box-sizing: border-box;
    box-shadow: 0px 2px 4px 1px rgba(32, 32, 32, 0.10000000149011612);
    padding: 10px;
    min-height: 25%;
    box-sizing: border-box;
    .title {
      font-size: 17px;
      margin: 10px;
    }
    .meal-type {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 5px;
      .mealImg {
        width: 100%;
        height: 100%;
        border-radius: 2%;
        margin-right: 8px;
      }
      .mealoutin {
        width: 78%;
        display: flex;
        flex-direction: column;
        .meal-name {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          .price-main {
            display: flex;
            align-items: center;
            div:nth-child(1) {
              margin-right: 5px;
            }
            .vipPrice {
              font-size: 17px;
              font-weight: bold;
              color: #ff1a1a;
              line-height: 19px;
            }
            .oldOrder {
              font-size: 12px;
              font-weight: 400;
              color: #b0b0b0;
              line-height: 19px;
              text-decoration: line-through;
            }
          }
        }
        .mealCount {
          font-size: 14px;
          color: #202020;
          font-weight: 400;
          margin-top: 15px;
          text-align: right
        }
      }
    }
    .pack {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      font-size: 14px;
      line-height: 28px;
    }
    .price-total {
      padding: 10px;
      border-top: 1px solid #eee;
      margin-top: 10px;
      .totalF {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .count {
          font-size: 12px;
          color: #606060;
        }
        .price {
          display: flex;
          .pricetext {
            font-size: 12px;
            color: #202020;
            line-height: 24px;
          }
          .peiceT {
            font-size: 20px;
          }
        }
      }
      .payment {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        color: #606060;
      }
    }
    .allCount{
      font-size: 14px;
      text-align: right;
      margin-top: 10px;
    }
    .remark {
      font-size: 14px;
      margin-top:5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      >.label {
        font-size:16px;
      
      }
      >.value {
        font-size: 12px;
        color: #969696;
        width: 200px;
        /*background: red;*/
        overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        text-align: right;
      }
    }
  }
  .orderMsg {
    margin: auto;
    margin-top: 10px;
    background-color: white;
    border-radius: 8px;
    color: #000;
    width: 95%;
    box-sizing: border-box;
    box-shadow: 0px 2px 4px 1px rgba(32, 32, 32, 0.10000000149011612);
    padding: 10px;
   
    box-sizing: border-box;
    >div {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      /*min-height: 26px;*/
      align-items: center;
      >.label {
        font-size:16px;
        line-height: 26px;

      }
      >.value {
        font-size: 12px;
        color: #969696;
        width: 200px;
        /*background: red;*/
        overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        text-align: right;
      }
      >.imglist {
        // width: 240px;
        text-align: right;
        >img {
          width: 60px;
          height: 60px;
          object-fit: cover;
          margin: 0 2px;
        }
      }
    }
  }
  .order-adress {
    margin: auto;
    margin-top: 10px;
    background-color: white;
    border-radius: 8px;
    color: #000;
    width: 95%;
    box-sizing: border-box;
    box-shadow: 0px 2px 4px 1px rgba(32, 32, 32, 0.10000000149011612);
    padding: 10px;
    min-height: 5%;
    margin-bottom: 10px;
    box-sizing: border-box;
    .counte {
      display: flex;
      justify-content: space-between;
      align-items: center;
      div:nth-child(1) {
        font-size: 14px;
        font-weight: normal;
      }
      div:nth-child(2) {
        font-size: 16px;
        color: #cececc;
      }
    }
  }
  .refund {
    margin: auto;
    margin-top: 10px;
    background-color: white;
    border-radius: 8px;
    color: #000;
    width: 95%;
    box-sizing: border-box;
    box-shadow: 0px 2px 4px 1px rgba(32, 32, 32, 0.10000000149011612);
    padding: 15px;
    min-height: 10%;
    margin-bottom: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-statue {
      font-size: 14px;
    }
    &-time {
      font-size: 12px;
      color: #969799;
      margin-top: 3px;
    }
    &-price {
      color: #f00;
      font-size: 14px;
    }
  }
  .pay-btn {
    width: 20%;
    height: 30px;
    background: #05a856;
    color: #fff;
    text-align: center;
    line-height: 30px;
    border-radius: 25px;
    font-size: 14px;
    margin: 20px 0 20px 76%;
  }
  .popup-main {
    padding: 14px;
    .title {
      text-align: center;
      font-size: 14px;
    }
    .border {
      border: 0.5px solid #000;
      margin-top: 10px;
    }
    .payment {
      width: 100%;
      min-height: 15%;
      background: #fff;
      margin: 2% auto 0 auto;
      border-radius: 7px;
      padding: 10px;
      box-sizing: border-box;
      .head {
        font-size: 15px;
        font-weight: bold;
        padding: 10px 12px;
      }
      .pay-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        // margin-left: 3%;
        border-bottom: 1px solid #f4f5f6;
        padding: 15px;
        img {
          width: 21px;
          height: 21px;
        }
        div {
          margin-left: 6px;
          font-size: 12px;
          font-weight: bold;
          // flex: 1;
        }
      }
    }
  }
  .btn-main {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 24px;
    .wid {
      width: 30%;
      font-size: 16px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      color: #fff;
      background: #05a856;
      border-radius: 5px;
    }
    .cancel-btn {
      background: #cccccc;
    }
  }
  .action-item {
    width: 100px;
    height: 20px;
    border-radius: 25px;
    padding: 10px 18px;
    color: #fff;
    background: linear-gradient(134deg, #4bd891 0%, #05a856 100%);
    font-size: 14px;
    color: #fff;
    line-height: 20px;
    text-align: center;
    margin-left: 225px;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .activeLok {
    color: #2ab1e7;
    background: #fff;
    border: 1px solid #2ab1e7;
  }
}
</style>
